<script setup>
import { BOverlay, BSpinner, BTable } from 'bootstrap-vue-next';
import { computed } from 'vue';

const props = defineProps({
  stickyHeader: {
    type: Boolean,
    default: false,
  },
});

const tableClass = computed(() => ({
  'sticky-header-table': props.stickyHeader,
}));

const responsiveValue = computed(() => props.stickyHeader ? false : 'md');
</script>

<template>
  <BTable
    :class="tableClass"
    :responsive="responsiveValue"
  >
    <template #table-busy>
      <div>&nbsp;</div>
      <BOverlay show>
        <template #overlay>
          <div class="d-flex align-items-center gap-2">
            <BSpinner />
          </div>
        </template>
      </BOverlay>
    </template>
    <template
      v-for="(_, name) in $slots"
      :key="name"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </BTable>
</template>
